import Page from "components/Page";
import { Props } from "./OutboundLogs";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const OutboundLogs = lazyWithRetry(() => import("./OutboundLogs"));

export default (props: Props) => (
  <Page>
    <OutboundLogs {...props} />
  </Page>
);
